<template>
  <div class="login-container">
    <div class="login-card">
      <img
        :src="require('../assets/logo-simba-RIDIMENSIONATO.png')"
        class="login-logo"
        alt="Simba Logo"
      />
      <el-form :model="loginData" label-position="top" class="login-form" @submit.prevent="logIn">
        <el-form-item label="Nome utente">
          <el-input v-model="loginData.username" placeholder="Inserisci username" />
        </el-form-item>
        <el-form-item label="Password">
          <el-input
            v-model="loginData.password"
            type="password"
            placeholder="Inserire password"
            show-password
          />
        </el-form-item>

        <el-button type="primary" class="login-btn" :loading="loading" native-type="submit" @click.prevent="logIn">
          Log in
        </el-button>
      </el-form>
      <router-link :to="{ path: `/reset-password` }" class="forgot-link">
        <el-link :underline="false">Hai dimenticato la password? clicca qui!</el-link>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { isLoggedStore } from '../store/logged';
import { reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { login, AUTH_ERROR_MESSAGES } from '../services/authService';

export default {
  name: 'LoginPage',
  components: {},
  setup() {
    const store = isLoggedStore();
    const router = useRouter();
    const loading = ref(false);
    const loginData = reactive({
      username: '',
      password: '',
    });

    const logIn = async () => {
      if (loading.value) return;
      loading.value = true;
      try {
        const { landing } = await login(loginData);
        router.push(landing);
      } catch (err) {
        ElMessage({
          message: AUTH_ERROR_MESSAGES[err.code] ?? AUTH_ERROR_MESSAGES.UNKNOWN,
          type: 'error',
        });
      } finally {
        loading.value = false;
      }
    };

    return {
      loginData,
      logIn,
      loading,
      store,
    };
  },
};
</script>

<style scoped>
.login-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #FAFAFA 0%, #F5F5F5 100%);
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.login-logo {
  width: 80px;
  height: auto;
  margin-bottom: 24px;
}

.login-form {
  text-align: left;
}

.login-form :deep(.el-form-item__label) {
  font-weight: 500;
  color: #171717;
}

.login-btn {
  width: 100%;
  margin-top: 8px;
  height: 44px;
  font-size: 1rem;
  font-weight: 500;
}

.forgot-link {
  display: block;
  margin-top: 20px;
  text-decoration: none;
}

.forgot-link :deep(.el-link) {
  font-size: 0.875rem;
  color: #737373;
}

.forgot-link :deep(.el-link:hover) {
  color: #4B30F2;
}
</style>
